import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {LinkSubjectToGroupContainerModel} from '../../../../../models/aggregates/group';


@Injectable({
  providedIn: 'root'
})
export class LinkSubjectToGroupService extends BaseApiTemplateService<LinkSubjectToGroupContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'users-group';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'users-group';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'users-group';
    this.httpClient = http;
  }
}
